import { MediaImageStandard } from 'components/Contentful'
import Section from 'components/Section'

export default function TrustMarkersSectionClientFdr({ title, trustMarkersGrid }) {
  const markers = trustMarkersGrid?.gridItemsCollection?.items ?? []
  const IMAGE_DIMENSIONS = {
    'FDR - BBB': {
      mobile: { h: 70, w: 124 },
      desktop: { h: 80, w: 142 },
      className: 'mx-auto h-[70px] w-[124px] lg:h-[80px] lg:w-[142px]',
    },
    'FDR - ABCS': {
      mobile: { h: 80, w: 80 },
      desktop: { h: 80, w: 80 },
      className: 'mx-auto h-[80px] w-[80px] lg:h-[80px] lg:w-[80px]',
    },
    'FDR - Forbes Advisor': {
      mobile: { h: 54, w: 177 },
      desktop: { h: 54, w: 210 },
      className: 'mx-auto h-[54px] w-[177px] lg:h-[54px] lg:w-[210px]',
    },
    'FDR - Money': {
      mobile: { h: 55, w: 133 },
      desktop: { h: 63, w: 152 },
      className: 'mx-auto h-[55px] w-[133px] lg:h-[63px] lg:w-[152px]',
    },
  }

  return (
    <Section backgroundColor="#E7ECF3" contain={false} className="overflow-hidden">
      <div className="px-6 pt-8 pb-2 lg:pt-12 lg:pb-6">
        {title?.textContent?.json && (
          <p className="text-center text-sm font-bold uppercase tracking-[.25em] text-[#5c708ad9]">
            {title.textContent.json.content?.[0]?.content?.[0]?.value}
          </p>
        )}
        <div className="px-8 lg:px-0">
          <div className="flex flex-col items-center justify-center lg:flex-row lg:py-6">
            {markers.map((marker, index) => {
              const dims = IMAGE_DIMENSIONS[marker?.image?.title]
              const image = marker?.image
              const imageTitle = marker?.image?.title

              if (!image) return null

              return (
                <div
                  key={marker?.sys?.id ?? `marker-${index}`}
                  className="flex justify-center w-full border-0 border-solid border-b-[1.5px] border-[#c0cbd8] py-6 last:border-b-0 lg:w-auto lg:border-0 lg:border-solid lg:border-r-[1.5px] lg:px-18 lg:py-3 lg:last:border-r-0"
                >
                  <MediaImageStandard
                    content={image}
                    alt={imageTitle}
                    layout="fixed"
                    height={dims ? dims.desktop.h : 84}
                    width={dims ? dims.desktop.w : 0}
                    {...(!dims && { style: { width: 'auto' } })}
                    className={dims ? dims.className : 'mx-auto h-[73px] w-auto lg:h-[84px]'}
                    priority
                  />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </Section>
  )
}
